<template>
  <div class="grid-view">
    <div v-show="view==='list'" class="main-content">
      <use-car-application-form-tab-list
        ref="useCarApplicationFormTabList"
        :lob="lob"
        source="useCarApplicationFormTab"
        @batchGenerateCarFormHandle="batchGenerateCarFormHandle"
      />
    </div>
    <car-form-tab-detail
      v-if="view==='detail'"
      ref="carFormTabDetail"
      :lob="lob"
      source="UseCarApplicationFormTab"
      @cancel="view='list'"
      @back="back"
    />
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInputNumber from '@/components/Cargo/Common/cargoInputNumber'
import cargoNumericStepper from '@/components/Cargo/Common/cargoNumericStepper'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import CarFormTabDetail from '@/components/Cargo/CarForm/carFormTabDetail'
import UseCarApplicationFormTabList from '@/components/Cargo/CarForm/useCarApplicationFormTabList'
import { CarForm } from '@/class/model/booking/CarForm'

export default {
  name: 'UseCarApplicationFormTab',
  components: { cargoAgGridWrapper, searchItem, CargoButtonGroupSlider, cargoAdvanceSelect, cargoInputNumber,
    cargoNumericStepper, CarFormTabDetail, UseCarApplicationFormTabList },
  props: {
    lob: { type: String, default: '' }
  },
  data() {
    return {
      SystemConstants,
      loading: false,
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      view: 'list'
    }
  },
  methods: {
    init() {
      if (this.view === 'list') {
        this.$refs.useCarApplicationFormTabList.queryHandler()
      }
    },
    back() {
      this.view = 'list'
      this.$nextTick(() => {
        this.$refs.useCarApplicationFormTabList.queryHandler()
      })
    },
    async batchGenerateCarFormHandle() {
      if (!this.$refs.useCarApplicationFormTabList.selectedRows || this.$refs.useCarApplicationFormTabList.selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      const port = this.$refs.useCarApplicationFormTabList.selectedRows[0].port
      const portRow = this.$refs.useCarApplicationFormTabList.selectedRows.find(p => p.port !== port)
      if (portRow) {
        const flag = await this.$confirm(this.$t('CargoMsg.Cargo_VehicleRequestDifferentPorts'), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.yes'),
          cancelButtonText: this.$t('common.btn.no'),
          distinguishCancelAndClose: true,
          type: 'warning'
        }).then(() => true).catch(() => false)
        if (!flag) {
          return
        }
      }
      this.$refs.useCarApplicationFormTabList.selectedRows
      this.view = 'detail'
      const carryingCmp = this.$refs.useCarApplicationFormTabList.selectedRows[0].carryingCmp
      const row = this.$refs.useCarApplicationFormTabList.selectedRows.find(p => p.carryingCmp !== carryingCmp)
      this.$nextTick(() => {
        const form = new CarForm().fillDefaultValue().getData()
        form.status = SystemConstants.CAR_FORM_STATUS_NOT_SENT.code
        if (!row) { // 全部一致 才带出
          form.carryingCmp = Number(carryingCmp)
        }
        form.useCarApplicationFormVos = this.$refs.useCarApplicationFormTabList.selectedRows
        this.$refs.carFormTabDetail.form = form
        this.$refs.carFormTabDetail.isEdit = true
        this.$refs.carFormTabDetail.init()
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .input-label {
    display: inline-block;
    width: 60px;
    color: #666666;
  }
  .el-form{
    /deep/ .el-input__inner{
      width: 300px;
    }
  }
</style>
